<template>
  <transition name="FadeLeft" v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </transition>
</template>

<script>
export default {
  name: "FadeLeft",
  props: {
    duration: {
      type: Number,
      default: 600
    },
    delay: {
      type: Number,
      default: 300
    }
  },
  computed: {
    hooks() {
      return {
        beforeEnter: this.setTiming,
        afterEnter: this.cleanUpTiming,
        beforeLeave: this.setTiming,
        afterLeave: this.cleanUpTiming,
        ...this.$listeners
      };
    }
  },
  methods: {
    setTiming(el) {
      el.style.transitionDuration = `${this.duration}ms`;
      el.style.transitionDelay = `${this.delay}ms`;
    },
    cleanUpTiming(el) {
      el.style.transitionDuration = "";
      el.style.transitionDelay = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.FadeLeft-enter-active,
.FadeLeft-leave-active {
  transition: opacity 0.6s ease-in-out 0.75s, transform 0.75s ease-out 0.75s;
}

.FadeLeft-enter {
  opacity: 0;
  transform: translateX(32px);
}

.FadeLeft-leave-to {
  opacity: 0;
  transform: translateX(-32px);
}
</style>
